import React from 'react'
import { usePathContext } from '../../PathContext'
import FeaturedReviews from '#src/components/FeaturedReviews'
import styles from './styles.css'

const ReviewFooterPageMetadata: React.SFC = () => {
  const pathContext = usePathContext()

  // This one has a special rendering treatment, just it's existence renders this
  const reviewFooterPageMetadata = pathContext.pathFlowPage.metadata.find(
    metadata => metadata.__typename === 'ReviewFooterPageMetadata'
  )

  if (!reviewFooterPageMetadata) {
    return null
  }

  return (
    <FeaturedReviews
      className={styles.reviews}
      forceFullGrid
      disableLinking={true}
      showMoreReviewsButton={false}
      departmentIds={[pathContext?.pathFlow.category?.department?.id]}
      version="v2"
    />
  )
}

export default ReviewFooterPageMetadata
